import { createRoot } from 'react-dom/client';

import { KeycloakService } from '@m/keycloak-service/KeycloakService';
import initApp from '@m/utils/initApp';
import IntakeApp from 'apps/intake';

import * as serviceWorker from './serviceWorker';

initApp('intake');

const root = createRoot(document.getElementById('root')!);

KeycloakService.initKeycloak('check-sso', () => {
  root.render(<IntakeApp />);
});

document.getElementById('initial-loader')?.remove();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
